"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var operatorMatch = {
  defined: 'should not be blank',
  undefined: 'should be blank',
  equals: 'equals',
  doesntEqual: "doesn't equal",
  includes: 'includes',
  doesntInclude: "doesn't include",
  startsWith: 'starts with',
  endsWith: 'ends with',
  '<': '< (as a number)',
  '<=': '<= (as a number)',
  '>=': '>= (as a number)',
  '>': '> (as a number)',
  regex: 'regex'
};
var _default = exports["default"] = function _default(obj) {
  try {
    var count = (JSON.stringify(obj).match(/dataConnector/g) || []).length;
    if (count === 0) {
      return '-';
    }
    if (count > 1) {
      return "".concat(count, " conditions");
    }
    var condition = obj.conditions[0];
    var result = "\"".concat(condition.dataConnector.title, "\" ").concat(operatorMatch[condition.operator] || condition.operator);
    if (condition.value) {
      result += " \"".concat(condition.value, "\"");
    }
    return result;
  } catch (e) {
    return '-';
  }
};